import React from "react";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@components/ui/select";
import { getDataTypeIcon } from "./commonData";

interface FieldValueTypeSelectorProps {
  value: string;
  onValueChange: (value: string) => void;
  className?: string;
}

const FieldValueTypeSelector: React.FC<FieldValueTypeSelectorProps> = ({
  value,
  onValueChange,
  className = "",
}) => {
  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger className={`w-full text-xs h-7 ${className}`}>
        <SelectValue placeholder="Select type" />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          <SelectItem value="stringValue" className="text-xs">
            <div className="flex items-center">
              {React.createElement(getDataTypeIcon("string"), {
                className: "h-3.5 w-3.5 mr-2 text-primaryAmber",
              })}
              String
            </div>
          </SelectItem>
          <SelectItem value="numberValue" className="text-xs">
            <div className="flex items-center">
              {React.createElement(getDataTypeIcon("number"), {
                className: "h-3.5 w-3.5 mr-2 text-primaryAmber",
              })}
              Number
            </div>
          </SelectItem>
          <SelectItem value="booleanValue" className="text-xs">
            <div className="flex items-center">
              {React.createElement(getDataTypeIcon("boolean"), {
                className: "h-3.5 w-3.5 mr-2 text-primaryAmber",
              })}
              Boolean
            </div>
          </SelectItem>
          <SelectItem value="arrayValue" className="text-xs">
            <div className="flex items-center">
              {React.createElement(getDataTypeIcon("array"), {
                className: "h-3.5 w-3.5 mr-2 text-primaryAmber",
              })}
              Array
            </div>
          </SelectItem>
          <SelectItem value="objectValue" className="text-xs">
            <div className="flex items-center">
              {React.createElement(getDataTypeIcon("object"), {
                className: "h-3.5 w-3.5 mr-2 text-primaryAmber",
              })}
              Object
            </div>
          </SelectItem>
        </SelectGroup>
      </SelectContent>
    </Select>
  );
};

export default FieldValueTypeSelector;
